// import {
// 	Tool
// } from "./Tool.js";
import {
	getDeviceTypeName
} from './nativeOtherOperate.js'

//自定义JS注册事件监听 connectWebViewJavascriptBridge 方法名可改
function connectWebViewJavascriptBridge(callback) {
	//console.log('connectWebViewJavascriptBridge-1',window.WebViewJavascriptBridge,window.WebViewJavascriptBridge.inited)
	if (window.WebViewJavascriptBridge && WebViewJavascriptBridge.inited) {
		console.log('connectWebViewJavascriptBridge-1-0')
		callback(window.WebViewJavascriptBridge)
	} else {
		console.log('connectWebViewJavascriptBridge-1-1')
		document.addEventListener(
			'WebViewJavascriptBridgeReady', () => {
				callback(window.WebViewJavascriptBridge)
			},
			false
		);
	}
}

//自定义JS注册事件监听 setupWebViewJavascriptBridge 方法名可改
function setupWebViewJavascriptBridge(callback) {
	console.log('setupWebViewJavascriptBridge',window.WebViewJavascriptBridge,callback)
	if (window.WebViewJavascriptBridge) {
		return callback(WebViewJavascriptBridge);
	}
	if (window.WVJBCallbacks) {
		return window.WVJBCallbacks.push(callback);
	}
	window.WVJBCallbacks = [callback];
	var WVJBIframe = document.createElement('iframe');
	WVJBIframe.style.display = 'none';
	WVJBIframe.src = 'https://__bridge_loaded__';
	document.documentElement.appendChild(WVJBIframe);
	setTimeout(function() {
		document.documentElement.removeChild(WVJBIframe)
	}, 0)
}

if (getDeviceTypeName()==='Android') {
	//注册回调函数，第一次连接时调用 初始化函数 connectWebViewJavascriptBridge和上面一致
	console.log('connectWebViewJavascriptBridge-0',window.WebViewJavascriptBridge)
	connectWebViewJavascriptBridge(function(bridge) {
		//初始化 必须有 Android 通过 JSBridge 调用 默认JS bridge.init bridgeWebView.send调用
		console.log('connectWebViewJavascriptBridge-2',bridge)
		// try{
		// 	bridge.init(function(message, callback) {
		// 		if (callback) {
		// 			callback({
		// 				'Javascript Responds': 'Android调用JS初始化方法!-=-' + message
		// 			});
		// 		}
		// 	});
		// }catch(err){
		// 	console.log('connectWebViewJavascriptBridge-error',err)
		// }
	})
} else if (getDeviceTypeName()==='iOS') {
	//注册回调函数，第一次连接时调用 初始化函数 setupWebViewJavascriptBridge和上面一致
	//ios 或许不用
	setupWebViewJavascriptBridge(function(bridge) {

	})
}


export default {
	registerHandler: function(name, fun) {
		if (getDeviceTypeName()==='Android') {
			connectWebViewJavascriptBridge(function(bridge) {
				//Android调用js方法：方法名称需要保持一致 ，并返回给Android通知
				bridge.registerHandler(name, function(data, responseCallback) {
					responseCallback(fun(data));
				});
			})
		} else if (getDeviceTypeName()==='iOS') {
			setupWebViewJavascriptBridge(function(bridge) {
				//ios调用js方法：方法名称需要保持一致 ，并返回给ios通知
				bridge.registerHandler(name, fun)
			})
		}
	},
	callHandler: function(name, data, fun) {
		if (getDeviceTypeName()==='Android') {
			connectWebViewJavascriptBridge(function(bridge) {
				//JS调用Android方法：接收Android传递过来的数据，并做处理
				bridge.callHandler(name, data, function(data) {
					fun(data);
				});
			})
		} else if (getDeviceTypeName()==='iOS') {
			setupWebViewJavascriptBridge(function(bridge) {
				//JS调用ios方法：接收ios传递过来的数据，并做处理
				bridge.callHandler(name, data, function(data) {
					fun(data);
				})
			})
		}
	}
}